var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangleSunsetGold = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
  id: "svg_1",
  fill: "none",
  d: "m0,0l24,0l0,24l-24,0l0,-24z"
}), /*#__PURE__*/React.createElement("path", {
  id: "svg_2",
  fill: "#ca972b",
  d: "m1,21l22,0l-11,-19l-11,19zm12,-3l-2,0l0,-2l2,0l0,2zm0,-4l-2,0l0,-4l2,0l0,4z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangleSunsetGold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warningTriangleSunsetGold.97c9b6efe7c745b0edc220b85545bffa.svg";